<template>
  <div v-show="hasOptions">
    <div
      v-if="!filter.hideTitle"
      class="font-medium border-b mb-2"
    >
      <span>{{ $t(filter.titleKey) }}</span>
    </div>
    <PricePickerInner
      v-if="filter.kind === CT_SEARCH_FILTER_KIND.PRICE && priceRange"
      :current-refinement="currentPriceRefinement"
      :max-range="priceRange"
      @refine="$emit('refine-price', $event)"
    />
    <CtRatingMenuInner
      v-else-if="filter.kind === CT_SEARCH_FILTER_KIND.RATING"
      :items="items"
      :refine="(value) => $emit('refine-rating', value)"
    />
    <CheckboxPicker
      v-else
      :items="items"
      :refine="(value) => $emit('refine', value)"
      :facet="filter.name"
    />
  </div>
</template>

<script setup lang="ts">
import type { ValueRange, ValueRangeOptional } from '~~/types/ValueRange';
import type { CtRefinementListItem } from '~~/types/productListing/CtSearchProductsResult';
import type { CtSearchFilterDefinition } from '~~/types/commercetools/productSearch';
import { CT_SEARCH_FILTER_KIND } from '~~/constants/commercetoolsProductSearch';

// CT version of CustomRefinementList, fed with mapped items instead of ais-* widgets.
defineOptions({ name: 'CtRefinementList' });

const props = withDefaults(defineProps<{
  filter: CtSearchFilterDefinition;
  items?: CtRefinementListItem[];
  priceRange?: ValueRange | null;
  currentPriceRefinement?: ValueRangeOptional;
}>(), {
  items: () => [],
  priceRange: null,
  currentPriceRefinement: () => ({ min: null, max: null }),
});

defineEmits<{
  'refine': [value: string];
  'refine-price': [range: ValueRange];
  'refine-rating': [value: string];
}>();

const hasOptions = computed(() => {

  if (props.filter.kind === CT_SEARCH_FILTER_KIND.PRICE) {

    return !!props.priceRange;

  }

  return props.items.length > 0;

});
</script>
